import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { sanitizeHtml } from "../../lib/sanitize";

// 타깃 공지 본문 — 그림·표 본문(body_html)이 있으면 그것을, 없으면 글자 본문(body · 없으면 summary)을 그린다(2026-10-28).
// 🔒 body_html 은 반드시 sanitizeHtml 을 거친다(공지사항 게시판 Notice.jsx 와 같은 규칙 · 허용 태그를 넓히지 말 것).
// 전면 안내(AnnouncementGate) · 「나에게 온 공지」(MyAnnouncementsPanel)가 같이 쓴다 — 두 화면의 본문이 어긋나지 않게.
export default function AnnouncementBody({ html, text, fontSize = "sm" }) {
  if (html && String(html).trim()) {
    return (
      <Box
        fontSize={fontSize}
        color="gray.700"
        lineHeight="1.75"
        overflowX="auto"
        sx={{
          "& table": { maxWidth: "100%" },
          "& img": { maxWidth: "100%", height: "auto" },
          "& a": { color: "brand.600", textDecoration: "underline" },
        }}
        data-testid="announcement-body-html"
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }}
      />
    );
  }
  return (
    <Text fontSize={fontSize} color="gray.700" whiteSpace="pre-wrap" lineHeight="1.85">
      {text}
    </Text>
  );
}
